export default __webpack_public_path__ + "static/media/IC00006-class_card.ea2015b7.svg";